import { createEvent, createStore } from 'effector'

export const actions = {
  setCommandes: createEvent<CommandeResponse[]>('setCommandes'),
  resetCommandes: createEvent('resetCommandes'),
  reset: createEvent('reset'),
}

const initialState: CommandeState = {
  commandes: [],
}

export const store = createStore<CommandeState>(initialState, { name: 'commande' })
  .on(actions.setCommandes, (s, commandes) => ({ ...s, commandes }))
  .on(actions.resetCommandes, (s) => ({ ...s, commandes: initialState.commandes }))
  .reset(actions.reset)
